import { GivingAccount } from 'generated/graphql';

export const renderGivingAccountName = (
  givingAccount?: Pick<GivingAccount, 'currencyCode' | 'provider' | 'name'> | null
): string =>
  givingAccount?.name
    ? `${givingAccount.name} (${givingAccount?.provider || ''} ${
        givingAccount?.currencyCode || ''
      })`
    : `${givingAccount?.provider || ''} ${givingAccount?.currencyCode || ''} Giving Account`;
